// Fixed widgets to hide while they cover anything in the exclusion list
const floaters = [
  {
    // The chat bubble: fade its holder, and lift it clear of the sticky ATC panel
    selector: '.woot--bubble-holder > .woot-widget-bubble.woot-elements--right:first-child',
    fadeTarget: (el) => el.parentElement,
    lift: true,
  },
  {
    // Postscript's "GET 10% OFF" teaser. The same iframe grows into the full
    // popup once tapped, so only hide it while it is teaser-sized - the open
    // popup covering an email field must not hide itself.
    // ponytail: 200px height guess separates teaser (~90px) from popup; revisit if Postscript restyles
    selector: '#ps__widget',
    fadeTarget: (el) => el,
    applies: (rect) => rect.height < 200,
  },
];

// List of classes to check against (Element B candidates)
const targetSelector = window.chatButtonExclusions;

const liftSelector = '.sticky-atc-panel';
const LIFT_GAP = 12;
let currentLift = 0;

function isOverlapping(rect1, rect2) {
  return !(
    rect1.top > rect2.bottom ||
    rect1.right < rect2.left ||
    rect1.bottom < rect2.top ||
    rect1.left > rect2.right
  );
}

function applyLift(bubble, rectA) {
  const panel = document.querySelector(liftSelector);
  let lift = 0;

  if (panel && getComputedStyle(panel).visibility === 'visible') {
    const rectPanel = panel.getBoundingClientRect();
    const panelRendered = rectPanel.width > 0 && rectPanel.height > 0;
    const panelOnScreen = rectPanel.top < window.innerHeight;
    const sharesColumn = !(rectPanel.right < rectA.left || rectPanel.left > rectA.right);

    if (panelRendered && panelOnScreen && sharesColumn) {
      const restingBottom = rectA.bottom + currentLift;
      lift = Math.max(0, restingBottom - rectPanel.top + LIFT_GAP);
    }
  }

  if (lift !== currentLift) {
    currentLift = lift;
    bubble.style.transform = lift ? `translateY(-${lift}px)` : '';
  }
}

function checkFloater(floater) {
  const elementA = document.querySelector(floater.selector);
  if (!elementA) return;

  const fade = floater.fadeTarget(elementA);
  fade.style.transition = 'opacity 200ms';

  if (floater.lift) applyLift(elementA, elementA.getBoundingClientRect());

  const rectA = elementA.getBoundingClientRect();
  let shouldHide = false;
  if (!floater.applies || floater.applies(rectA)) {
    for (const element of document.querySelectorAll(targetSelector)) {
      if (isOverlapping(rectA, element.getBoundingClientRect())) {
        shouldHide = true;
        break;
      }
    }
  }

  if (shouldHide) {
    fade.style.opacity = '0';
    fade.style.pointerEvents = 'none';
  } else {
    fade.style.opacity = null;
    fade.style.pointerEvents = null;
  }
}

function checkOverlap() {
  floaters.forEach(checkFloater);
}

// Run on scroll and resize (important since the floaters are fixed)
window.addEventListener('scroll', checkOverlap);
window.addEventListener('resize', checkOverlap);

// Initial check
checkOverlap();
setInterval(() => {
  checkOverlap();
}, 1000)
